"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotionDetail = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
function MotionDetail(props) {
    const { detail: { parts, selectedPartIndex, allFaded }, onClick, onFadeAll, onFade, } = props;
    if (!parts) {
        return null;
    }
    const handleFadeAll = (e) => {
        onFadeAll();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    };
    const handlePartItemClick = (e, identifier, index) => {
        onClick(identifier, index);
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { role: "group", "data-e2e": 'MotionDetail_div', children: [(0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'MotionDetail_Container', children: [(0, jsx_runtime_1.jsx)(Heading, { "data-e2e": 'MotionDetail_Heading', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.motion.otherMuscles) }), (0, jsx_runtime_1.jsx)(FadeAllButton, { selected: allFaded, onClick: handleFadeAll, "data-e2e": 'MotionDetail_FadeAllButton', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.motion.fadeAll) })] }), parts.map(({ name, identifier, isFaded }, i) => ((0, jsx_runtime_1.jsxs)(PartItem, { selected: i === selectedPartIndex, onClick: e => handlePartItemClick(e, identifier, i), role: "menuitem", "aria-current": i === selectedPartIndex, "data-e2e": 'MotionDetail_PartItem', children: [name, (0, jsx_runtime_1.jsx)(FadeButton, { selected: isFaded, "$visible": i === selectedPartIndex || isFaded, onClick: onFade(identifier, i), "data-e2e": 'MotionDetail_FadeButton', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.motion.fade) })] }, i)))] }));
}
exports.MotionDetail = MotionDetail;
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin: 8px 0 8px 6px;

  cursor: default;
`;
const Heading = styled_components_1.default.div `
  width: 50%;
  margin-top: 6px;

  font-size: 14px;
  text-transform: uppercase;
`;
const PartItem = (0, styled_components_1.default)(Container) `
  min-height: 30px;
  margin-right: 4px;

  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  font-size: 14px;

  cursor: pointer;
`;
const FadeButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  height: 30px;
  margin: auto 0;
  padding: 0;

  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  font-size: 14px;
  text-transform: uppercase;

  visibility: ${({ $visible = true }) => ($visible ? 'visible' : 'hidden')};
`;
const FadeAllButton = (0, styled_components_1.default)(FadeButton) `
  min-width: 80px;
`;
